import type { ReactElement } from 'react';
import Checkbox from 'components/shared/Checkbox';
import SkuTags from 'components/shared/SkuTags';
import { preferencesByTagName } from 'utils/constants';

type Props = {
  preferenceFilters: string[];
  filteredResultCount: number;
  setPreferenceFilters: (preferenceFilters:string[]) => void;
  setShowPreferenceFilterSelection: (arg: boolean) => void;
  isDrawer?: boolean;
};

function PreferenceFilterSelection({
  preferenceFilters,
  filteredResultCount,
  setPreferenceFilters,
  setShowPreferenceFilterSelection,
  isDrawer,
}: Props): ReactElement {
  const handleSelectPreference = (selectedPreference: string) => {
    if (preferenceFilters.includes(selectedPreference)) {
      setPreferenceFilters(preferenceFilters.filter((tag) => tag !== selectedPreference));
    } else {
      setPreferenceFilters([
        ...preferenceFilters,
        selectedPreference,
      ]);
    }
  };

  const handleClearAll = () => {
    setPreferenceFilters([]);
    setShowPreferenceFilterSelection(false);
  };

  return (
    <div className={['c-filter-offcanvas', isDrawer ? 'is-drawer' : ''].join(' ')}>
      <div className="c-filter-offcanvas__content">
        <h2 className="c-filter-offcanvas__heading c-heading--brand-6">
          Preferences
        </h2>
        <hr className="c-filter-offcanvas__divider" />
        <div className="c-filter-offcanvas__options">
          {Object.keys(preferencesByTagName).map((tag, i) => (
            <div className="c-filter-offcanvas__checkbox" key={tag}>
              <Checkbox
                id={tag}
                label={(
                  <div className="c-filter-offcanvas__checkbox-label">
                    <SkuTags tags={[{ name: tag, id: i, promo: false }]} />
                    {`${preferencesByTagName[tag]}`}
                  </div>
                      )}
                checked={preferenceFilters.includes(tag)}
                onChange={(e) => handleSelectPreference(e.target.id)}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="c-filter-offcanvas__buttons">
        <button type="button" onClick={handleClearAll}>
          Clear All
        </button>
        <button
          className="c-button--primary c-filter-offcanvas__primary-button"
          type="button"
          onClick={() => setShowPreferenceFilterSelection(false)}
        >
          {`View ${filteredResultCount} Results`}
        </button>
      </div>
    </div>
  );
}

export default PreferenceFilterSelection;
